import firebase from 'firebase/app'

export default {
  state: {
    user: null,
    // Whether Firebase has fired its first onAuthStateChanged event, i.e. the
    // persisted session (if any) has been restored. Router guards must wait for
    // this before deciding to redirect to /signin, otherwise a hard refresh on
    // a deep link bounces the (still authenticated) user to the login page.
    authReady: false
  },
  getters: {
    user (state) {
      return state.user
    },
    authReady (state) {
      return state.authReady
    }
  },
  // synchronous
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setAuthReady (state, payload) {
      state.authReady = payload
    }
  },
  // asynchronous
  actions: {
    signUserUp ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(data => {
          // console.log(data)
          commit('setLoading', false)
          const newUser = {
            id: data.user.uid,
            email: data.user.email,
            name: payload.name,
            lastAccess: firebase.database.ServerValue.TIMESTAMP,
            createdAt: firebase.database.ServerValue.TIMESTAMP
          }
          commit('setUser', newUser)
          return firebase.database().ref('users').child(newUser.id).set(newUser)
        })
        .then(() => {
          return firebase.auth().currentUser.updateProfile({
            displayName: payload.name
          })
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err.message)
        })
    },
    signUserIn ({ commit, dispatch }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(data => {
          // console.log(data)
          commit('setLoading', false)
          const newUser = {
            id: data.user.uid,
            email: data.user.email,
            name: data.user.displayName
          }
          commit('setUser', newUser)
          localStorage.setItem('token', data.user.ya)
          dispatch('loadDeviceFeaturesV2')
          dispatch('loadAeiHouses')
          return firebase.database().ref('users').child(newUser.id).update({
            lastAccess: firebase.database.ServerValue.TIMESTAMP
          })
        })
        .then(() => {
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err.message)
        })
    },
    signUserOut ({ commit }) {
      // console.log('sign user out')
      firebase.auth().signOut()
      localStorage.setItem('token', null)
      commit('clearError')
      commit('setUser', null)
      commit('clearLoadedDeviceFeaturesV2')
      commit('clearAei')
    },
    autoSignUserIn ({ commit, dispatch }, payload) {
      // console.log('auto sign user in')
      // console.log(payload)
      commit('setUser', {
        id: payload.uid,
        email: payload.email,
        name: payload.displayName
      })
      dispatch('loadDeviceFeaturesV2')
      dispatch('loadAeiHouses')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js